import React from 'react';
import { PauseCircleOutlined } from '@ant-design/icons';
import { getTranslatedLabel, VOICE_ACTIVE_COLOR } from './FooterVoice.constants';
import VoiceIconButton from './VoiceIconButton';
import VoiceWaveform from './VoiceWaveform';

const RecordingVoicePreview = ({
    recordSeconds,
    waveRef,
    wavePathRef,
    liveRecordingBars,
    pauseRecording,
    formatTime,
    t,
    isDarkMode,
    iconSize,
    disableTooltip,
}) => {
    const tt = (key, fallback) => getTranslatedLabel(t, key, fallback);

    return (
        <div
            data-testid="voice-recording"
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                width: '100%',
                minWidth: 0,
                padding: '6px 8px',
                border: `1px solid ${isDarkMode ? '#434343' : '#e6edf3'}`,
                borderRadius: 999,
                background: isDarkMode ? '#262626' : '#f8fafc'
            }}
        >
            <VoiceIconButton
                label={tt('stop', 'Stop')}
                danger
                isDarkMode={isDarkMode}
                disableTooltip={disableTooltip}
                icon={<PauseCircleOutlined style={{ fontSize: iconSize }} />}
                onClick={pauseRecording}
            />

            <span
                style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: isDarkMode ? '#fff' : '#334155',
                    whiteSpace: 'nowrap'
                }}
            >
                {formatTime(recordSeconds)}
            </span>

            <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
                <div ref={waveRef} style={{ width: '100%', height: 32, overflow: 'hidden' }}>
                    <VoiceWaveform
                        progress={100}
                        bars={liveRecordingBars}
                        isDarkMode={isDarkMode}
                        activeColor={VOICE_ACTIVE_COLOR}
                        width="100%"
                    />
                </div>
            </div>
        </div>
    );
};

export default RecordingVoicePreview;
